import MarsMap from '../../common/map-components/map/Map';
import React, { useEffect, useState } from 'react';
import { MarsApiService as api } from '../../../api/mars-api-service';
import { MarsApiConfig as apiConfig } from '../../../api/mars-api-config';
import { useLoaderContext } from '../../../contexts/LoaderContext';
import { Legend, Markers } from '../../../types/map';
import { LatLngExpression, LatLngLiteral } from 'leaflet';
import { useTranslation } from 'react-i18next';
import LiveTrackingInfoWindow from '../../vessel-info/live-tracking-info-window/LiveTrackingInfoWindow';
import countryList from '../../../components/Country.json';
import {
  MyWatchList,
  MyWatchListFleet,
  MyWatchListFleetVessel,
} from '../../../types/my-watch-list';

export default function MyWatchListGadget() {
  const { setIsLoading } = useLoaderContext();
  const [showNoDataFound, setShowNoDataFound] = useState<boolean>(false);
  const [legendList, setLegendList] = useState<Legend[]>([]);
  const [markers, setMarkers] = useState<Markers[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    getMyWatchListGadget();
  }, []);

  const getMyWatchListGadget = async () => {
    await api
      .get({ url: apiConfig.myWatchListGadget }, setIsLoading)
      .then((data: MyWatchList) => {
        if (data) {
          const legends: Legend[] = data.fleetList.map(
            (fleet: MyWatchListFleet) => ({
              label: fleet.fleetName,
              color: fleet.color,
              isCircle: true,
            })
          );
          setLegendList(legends);
          const mainMarkers: Markers[] = data.fleetVesselList
            .filter(
              (v: MyWatchListFleetVessel) =>
                v.vesselLiveDataDetails?.lat && v.vesselLiveDataDetails?.lon
            )
            .map((vessel: MyWatchListFleetVessel) => ({
              iconName: 'arrowSymbol',
              iconRotation: vessel.vesselLiveDataDetails.heading,
              coordinates: {
                lat: vessel.vesselLiveDataDetails.lat,
                lng: vessel.vesselLiveDataDetails.lon,
              },
              markerColor: vessel.fleetColor,
              infoWindowContent: (
                <LiveTrackingInfoWindow
                  position={vessel.vesselLiveDataDetails!}
                  vesselDetails={vessel.vesselDetails!}
                  flag={
                    countryList.find(
                      (countryItem) =>
                        countryItem.iso_3 == vessel.vesselDetails?.iso3
                    )?.flag || ''
                  }
                  t={t as any}
                />
              ),
            }));

          setMarkers(mainMarkers);
        } else {
          setShowNoDataFound(true);
        }
      });
  };

  return (
    <div className={'m-c-grid m-c-block-grid-list'} style={{ height: '400px' }}>
      {
        <MarsMap
          markers={markers}
          isDrawVisible={false}
          zoom={5}
          legendsList={legendList}
          isFilterVisible={false}
          closePopupOnOutsideClick={true}
        />
      }
    </div>
  );
}
